export const ALERT_VIEWS = {
  chat: 'chat',
  list: 'list',
};

export const ROLE = {
  user: 'user',
  assistant: 'assistant',
};
